import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions.js';
import * as agui from '../shared/v4/';


class TestConfirmModalOkCancelV4 extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[TestModalV4.jsx] ';
        this.state = {}
        this.onCloseOrOpen = this.onCloseOrOpen.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        console.log(this.componentName + ': onClick');
        this.props.showPopUP(false);
    }

    onCloseOrOpen() {
        console.log(this.componentName + ': onClose');
        let isShow = false;
        if (event !== undefined && event !== null && event.target.id !== undefined && event.target.id !== null) {
            if (event.target.id === 'showPopUpConferma') {
                isShow = true;
                this.props.showPopUP(isShow);
            } else {
                this.props.showPopUP(isShow);S
            }
        }
    }

    render() {

        let showModal = false;
        if (this.props.showPopUp !== undefined && this.props.showPopUp !== null) {
            showModal = this.props.showPopUp;
        }

        return (
            <div>
                <h1>TEST MODAL </h1>

                <div className="d-flex flex-row" >

                    <div className="p-2">
                        <button type="button" className="btn btn-primary" id='showPopUpConferma' data-toggle="modal" data-target="#exampleModalLong" onClick={this.onCloseOrOpen}>
                            Launch test ModalOkCancelV4
                    </button>
                    </div>

                </div>

                <agui.ConfirmModalOkCancelV4 show={showModal} id="exampleModalLong">
                    <agui.ConfirmModalOkCancelV4.Header  />
                    <agui.ConfirmModalOkCancelV4.Body />
                    <agui.ConfirmModalOkCancelV4.Footer confirmOnClick={this.onClick} />
                </agui.ConfirmModalOkCancelV4 >

            </div>
        );
    }
};

function mapStateToProps(state, ownProps) {
    return {
        showPopUp: state.app.showPopUp,
    }
}

function mapDispatchToProps(dispatch) {
    console.log('[TestModalV4.JSX]: mapDispatchToProps');
    return {
        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TestConfirmModalOkCancelV4);
